import { render, staticRenderFns } from "./QCollapseItem.vue?vue&type=template&id=0c5f5e0e&"
import script from "./QCollapseItem.vue?vue&type=script&lang=js&"
export * from "./QCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports